import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorMessage } from '../../enums/error';

type MetaState = {
  loading: boolean;
  error_message: ErrorMessage | null;
};

const initialState: MetaState = {
  loading: false,
  error_message: null,
};

export const metaSlice = createSlice({
  name: 'meta',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setErrorMessage: (state, action: PayloadAction<ErrorMessage>) => {
      state.error_message = action.payload;
    },
  },
});

export default metaSlice.reducer;
